import ScheduleListRow from './ScheduleListRow';
export default class Task extends ScheduleListRow {
	constructor(params) {
		super(params);
		
		if (params.schedules !== undefined)
			this.schedules = params.schedules;
		else
			this.schedules = new Array();

		if (params.member_code !== undefined)
			this.member_code = params.member_code;
		if (params.project_code !== undefined)
			this.project_code = params.project_code;
		
		this.item_type = ScheduleListRow.ITEM_TYPE.TASK;
	}
}